<template>
    <vx-table-row>
        <vx-table-row-title>
            <div class="flex flex-col items-start">
                <vx-badge color="slate" size="xs" class="font-mono" data-test="brand-id">
                    {{ props.modelValue.brand_id }}
                </vx-badge>
                <span class="text-xs font-normal text-slate-500" data-test="source">{{ sourceLabel }}</span>
            </div>
        </vx-table-row-title>

        <vx-table-row-item data-test="display-name">
            <template v-slot:label> Name: </template>
            <span class="text-sm font-bold line-clamp-2" :title="props.modelValue.display_name ?? undefined">
                {{ props.modelValue.display_name || '—' }}
            </span>
        </vx-table-row-item>

        <vx-table-row-item data-test="entity">
            <template v-slot:label> Entity: </template>
            <div class="flex flex-col">
                <span>{{ props.modelValue.entity_type || '—' }}</span>
                <span class="text-xs text-slate-500">{{ props.modelValue.identity_status || '—' }}</span>
            </div>
        </vx-table-row-item>

        <vx-table-row-item data-test="vetting">
            <template v-slot:label> Vetting: </template>
            <div v-if="props.modelValue.vetting_score !== null" class="flex flex-col">
                <span class="font-bold">{{ props.modelValue.vetting_score }}</span>
                <span v-if="vettingDetails" class="text-xs text-slate-500">{{ vettingDetails }}</span>
            </div>
            <span v-else>—</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="campaigns-count">
            <template v-slot:label> Campaigns: </template>
            {{ props.modelValue.campaigns_count }}
        </vx-table-row-item>

        <vx-table-row-item data-test="synced-at">
            <template v-slot:label> Synced: </template>
            <vx-popover hover :arrow="true" placement="top" :key="syncedAtKey">
                {{ fromNow(props.modelValue.synced_at) }}
                <template v-slot:content>
                    {{ shortDateTime(props.modelValue.synced_at) }}
                </template>
            </vx-popover>
        </vx-table-row-item>
    </vx-table-row>
</template>

<script lang="ts" setup>
import { VxBadge, VxPopover, VxTableRow, VxTableRowItem, VxTableRowTitle } from '@voxie/frontend-components';
import { useInterval } from '@vueuse/core';
import { computed } from 'vue';
import type { TcrBrand } from '~/services/adminTenDlcClient.types';
import { fromNow, shortDateTime } from '~/utils/date';

const props = defineProps<{
    modelValue: TcrBrand;
}>();

const syncedAtKey = useInterval(60000);

const sourceLabel = computed(() => (props.modelValue.source === 'twilio' ? 'via Twilio' : 'via TCR'));

const vettingDetails = computed(() =>
    [props.modelValue.vetting_class, props.modelValue.vetting_status].filter((value) => !!value).join(' · ')
);
</script>
